module.exports = __webpack_public_path__ + "static/img/check-pc.f6c6f632.png";